export const ROADMAP = {
  nav: "nav-bar",
  navLink: (id) => `nav-link-${id}`,
  hero: "hero-section",
  heroPrimaryCta: "hero-primary-cta",
  heroSecondaryCta: "hero-secondary-cta",
  execSummary: "exec-summary-section",
  phasesSection: "phases-section",
  phaseCard: (id) => `phase-card-${id}`,
  phasePanel: "phase-detail-panel",
  modulesSection: "modules-section",
  moduleCard: (id) => `module-card-${id}`,
  moduleDialog: "module-dialog",
  gr8agenticSection: "gr8agentic-section",
  gr8agenticTab: (id) => `gr8agentic-tab-${id}`,
  whiteLabelSection: "whitelabel-section",
  kpiSection: "kpi-section",
  integrationsSection: "integrations-section",
  rolesSection: "roles-section",
  risksSection: "risks-section",
  ctaSection: "cta-section",
  demoForm: "demo-form",
  demoFormName: "demo-form-name",
  demoFormEmail: "demo-form-email",
  demoFormCompany: "demo-form-company",
  demoFormMessage: "demo-form-message",
  demoFormSubmit: "demo-form-submit",
};
